/**
 * hnhóm theo
 */
export default {
  BudgetSubItem: 'budget_sub_item_code', // 'tiểu mục',
  BudgetItem: 'budget_item_code', // 'mục',
  BudgetChapter: 'budget_chapter_code', // 'chương',
  Branch: 'budget_sub_kind_item_code', // 'ngành',
  BudgetSource: 'budget_source_property_code', // 'nguồn'
};
